export const CREATE_TOURNAMENT = "CREATE_TOURNAMENT";
export const DELETE_TOURNAMENT = "DELETE_TOURNAMENT";
export const ADD_TEAM = "ADD_TEAM";
export const UPDATE_TEAM = "UPDATE_TEAM";
export const DELETE_TEAM = "DELETE_TEAM";
export const SET_MATCH_WINNER = "SET_MATCH_WINNER";
export const SET_MATCH_RESULT = "SET_MATCH_RESULT";
export const REQUEST_MATCH_REPLAY = "REQUEST_MATCH_REPLAY";
export const RESET_TOURNAMENT_BRACKET = "RESET_TOURNAMENT_BRACKET";
export const GENERATE_TOURNAMENT_BRACKET = "GENERATE_TOURNAMENT_BRACKET";

export const TOURNAMENT_MODE_SINGLE = "single_elimination";
export const TOURNAMENT_MODE_DOUBLE = "double_elimination";
export const TOURNAMENT_MODE_GROUPS = "groups_playoffs";

export const SEEDING_STRATEGY_RANDOM = "random";
export const SEEDING_STRATEGY_MANUAL = "manual";
export const SEEDING_STRATEGY_RATING = "rating";
